import { BaseService } from 'services/baseService';
import { DepartmentModel } from 'types/models/DepartmentModel';

class DepartmentService extends BaseService<DepartmentModel> {
  controllerName = 'departments';
}

export const departmentService = new DepartmentService();
